Object.defineProperty(exports, "__esModule", {
  value: true,
});

const { print } = require("graphql/language/printer");
const { getOperationAST } = require("graphql");

function getOperationName(doc) {
  return getOperationAST(doc)?.name?.value;
}

const defaultParams = {
  endpoint: "/graphql",
  credentials: "same-origin",
};

class GraphQLFetchClient {
  beforeRequestInterceptor;
  afterRequestInterceptor;
  onErrorInterceptor;

  constructor(options = defaultParams) {
    this.endpoint = options.endpoint;
    this.ssr = options.ssr;
    this.defaultHeaders = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    this.credentials = options.credentials;
  }

  async fetcher(queryDocument, variables, options) {
    const operationName = getOperationName(queryDocument);
    const query = print(queryDocument);
    const headers = new Headers(this.defaultHeaders);

    /* Additional options */
    if (options) {
      /* Query-relative headers */
      if (options.headers) {
        Object.entries(options.headers).forEach(([key, value]) =>
          headers.append(key, value)
        );
      }

      /* Some other options, in future */
      /* ... */
    }

    const fetchOptions = {
      method: "POST",
      headers,
      credentials: this.ssr ? "include" : this.credentials,
      mode: this.ssr ? "no-cors" : "cors",
      body: JSON.stringify({
        operationName,
        query,
        variables,
      }),
    };

    const context = {
      headers,
      queryDocument,
      query,
      operationName,
      fetchOptions,
    };

    if (this.beforeRequestInterceptor) {
      await this.beforeRequestInterceptor.call(this, context);
    }

    const response = await fetch(this.endpoint, context.fetchOptions);

    if (this.afterRequestInterceptor) {
      await this.afterRequestInterceptor.call(this, response, context);
    }

    if (!response.ok) {
      if (this.onErrorInterceptor) {
        await this.onErrorInterceptor(
          new Error(`${response.status} ${response.statusText}`),
          context,
          response
        );
      }
    }

    return await response.json();
  }

  query({ query, variables, options }) {
    return this.fetcher(query, variables, options);
  }

  mutate({ mutation, variables, options }) {
    return this.fetcher(mutation, variables, options);
  }

  resetStore() {
    /* do nothing, apollo legacy */
  }

  beforeRequest(interceptor) {
    if (typeof interceptor === "function") {
      this.beforeRequestInterceptor = interceptor;
    }
  }

  afterRequest(interceptor) {
    if (typeof interceptor === "function") {
      this.afterRequestInterceptor = interceptor;
    }
  }

  onError(interceptor) {
    if (typeof interceptor === "function") {
      this.onErrorInterceptor = interceptor;
    }
  }
}

module.exports = {
  GraphQLFetchClient,
};
